import { Box, Container, Heading, Text, Stack } from "@chakra-ui/react";

export default function AboutUs() {
  return (
    <Box py={{ base: 10, md: 16 }}>
      <Container maxW="4xl">
        <Heading size="2xl" mb={4}>
          About Us
        </Heading>
        <Stack spacing={4} fontSize="md">
          <Text>
            We’re Consumer Advocate Reviews. Our mission is to make complex
            financial decisions clearer with honest, data-driven comparisons and
            practical guides.
          </Text>
          <Text>
            We maintain editorial independence from advertisers. Our methodology
            and data sources are published and updated regularly.
          </Text>
        </Stack>
      </Container>
    </Box>
  );
}
